module.exports = __webpack_public_path__ + "static/fran-ferri-f6274e5344cbbd6c890af62198670497.jpg";